import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useHttpClient, type SuccessResponse } from "./httpClient";
import { storeToRefs } from "pinia";
import type { Translations } from "shared/translations/domain/translations";

export interface CreateEntityApiOptions<TResponse extends SuccessResponse> {
  url: string;
  translate: (translations: Translations) => CreateEntityApiTranslations;
  processOk: (response: Response) => Promise<TResponse>;
}

export interface CreateEntityApiTranslations {
  title: string;
  error: string;
}

export interface CreateEntityRequest<T> {
  entity: T;
}

export function useCreateEntityApi<TRequest, TResponse extends SuccessResponse>(options: CreateEntityApiOptions<TResponse>) {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: CreateEntityRequest<TRequest>) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(options.url), {
      method: 'POST',
      headers,
      body: JSON.stringify(action.entity)
    });

    const text = options.translate(translations.value);

    const response = await httpClient.action<TResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk: options.processOk
    });

    return response;
  }
}
